module.exports = __webpack_public_path__ + "static/media/r8.887891c6.jpg";